import { render, staticRenderFns } from "./EducationalJoiningApplicationUpdate.vue?vue&type=template&id=71d53ac9&"
import script from "./EducationalJoiningApplicationUpdate.vue?vue&type=script&lang=js&"
export * from "./EducationalJoiningApplicationUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports